<template>
	<AppDialog ref="dialog_container" dialogName="AddVerifiedEmailDialog" width="540px">
		<div class="verify-email-dialog display-flex flex-column">
			<span class="dialog-title flex-centerize">Add {{ typeToVerifyText }} email address</span>
			<div class="font-size-lg font-weight-500">Email address you wish to verify</div>
			<AppTextField v-model="emailToVerify" outlined hide-details placeholder="john@custom-email-domain.com" />
			<div class="flex-centerize">
				<PrimaryButton class="verification-btn" :disabled="!isValidEmail || isLoading" :loading="isLoading" @click="sendVerificationEmail"
					>Send verification email</PrimaryButton
				>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import { DataTypeEvaluator } from '@ply-io/data-types';

import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { sendVerifyEmail } from '@/store/modules/accountEmailDomains/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';
import { VerificationEmailTypes } from '@/utils/transactional-emails.const';

const { isEmail } = new DataTypeEvaluator();

export default {
	name: 'AddVerifiedEmailDialog',
	components: { AppDialog },
	props: {
		typeToVerify: { type: String },
		dialogPromiseHandlers: { type: Object },
	},
	methods: {
		...mapActionsShorthand({ sendVerifyEmail }),
		async sendVerificationEmail() {
			if (!this.isValidEmail) {
				this.$toast.error('Invalid email address');
				return;
			}
			this.isLoading = true;
			try {
				await this.sendVerifyEmail(this.emailToVerify);
				await AppDialogManagerService.openEmailVerificationDialog({
					emailToVerify: this.emailToVerify,
					typeToVerify: this.typeToVerify,
				});
				this.close();
			} catch (error) {
				console.error('Failed to send verification email', error);
				this.$toast.error('Failed to send verification email to: ' + this.emailToVerify);
			} finally {
				this.isLoading = false;
			}
		},
		close() {
			AppDialogManagerService.closeCurrentDialog();
		},
	},
	computed: {
		isValidEmail() {
			return isEmail(this.emailToVerify);
		},
		typeToVerifyText() {
			return this.typeToVerify === VerificationEmailTypes.REPLY_TO ? 'a reply-to' : 'an unsubscribe contact';
		},
	},
	data() {
		return {
			emailToVerify: '',
			isLoading: false,
			isWrongCode: false,
			isEmailResent: false,
		};
	},
};
</script>

<style scoped lang="scss">
.verify-email-dialog {
	border-radius: 15px !important;
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16) !important;
	padding: 20px 30px 14px 30px;

	::v-deep(.widget-preview) {
		min-height: 350px !important;
	}
	.verification-btn {
		width: 230px;
	}
}
</style>
